<template>
  <LoadingData v-if="loadData" />
  <div v-else class="mt-3">
    <h2 class="fw-bold text-teal">Selecione um Centro de Custo</h2>
    <div v-if="centrosCustosPais.length > 0" class="row">
      <div
        v-for="(centroCustoPai, index) in centrosCustosPais"
        :key="index"
        class="col-lg-4 col-md-6 mb-3"
      >
        <router-link
          :to="`/centro-de-custo/${centroCustoPai.codCCustoPai}`"
          :title="centroCustoPai.nomeCCustoPai"
        >
          <div
            class="card h-100 border-start border-start-width-3 border-start-teal"
          >
            <div class="card-body d-flex align-items-center py-1">
              <h6 class="text-teal fw-bold mb-0">
                {{ centroCustoPai.codCCustoPai }} -
                {{ centroCustoPai.nomeCCustoPai }}
              </h6>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <h6 v-else>Nenhum centro de custo encontrado.</h6>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'

export default {
  name: 'Home',

  components: {
    LoadingData,
  },

  data() {
    return {
      loadData: true,
      centrosCustosPais: [],
    }
  },

  methods: {
    async getCentrosCustosPais() {
      try {
        this.centrosCustosPais = await this.$store.dispatch(
          'getCentrosCustosPais',
        )
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.getCentrosCustosPais()
  },
}
</script>
